module.exports = __webpack_public_path__ + "media/images/meeting/ic_date-daf57cad882c998521c747d793c396b4.svg";